<template>
  <section class="view-stack">
    <article class="dashboard-panel redeem-panel">
      <div>
        <h2>兑换码</h2>
        <p>输入兑换码后可直接兑换余额套餐或日卡套餐。</p>
      </div>
      <el-input v-model.trim="redeemCode" placeholder="请输入兑换码，例如 A1B2-C3D4-E5F6-G7H8">
        <el-button slot="append" :loading="submitting" @click="submitRedeem">兑换</el-button>
      </el-input>
    </article>

    <article class="dashboard-panel">
      <div class="panel-heading">
        <div>
          <h2>兑换记录</h2>
          <p>最近兑换成功的套餐记录。</p>
        </div>
      </div>
      <el-table v-loading="loading" :data="redeemRows" class="dashboard-table redeem-table" empty-text="暂无兑换记录">
        <el-table-column prop="redeemCode" label="兑换码" width="180"></el-table-column>
        <el-table-column label="套餐" min-width="180">
          <template slot-scope="{ row }">
            <div class="primary-cell">
              <strong>{{ row.packageName || '-' }}</strong>
              <span>{{ formatReward(row) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分组" width="120">
          <template slot-scope="{ row }">
            {{ row.groupType === 'MONTH_CARD' ? '日卡' : '余额' }}
          </template>
        </el-table-column>
        <el-table-column label="使用时间" width="180">
          <template slot-scope="{ row }">
            {{ formatTime(row.usedTime) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="110">
          <template slot-scope="{ row }">
            {{ row.status === 1 ? '已使用' : '未使用' }}
          </template>
        </el-table-column>
      </el-table>

      <div v-if="redeemRows.length" class="redeem-mobile-list">
        <article v-for="row in redeemRows" :key="row.id || row.redeemCode" class="redeem-mobile-card">
          <div class="redeem-mobile-card__header">
            <strong>{{ row.packageName || '-' }}</strong>
            <el-tag :type="row.groupType === 'MONTH_CARD' ? 'warning' : 'success'" size="small">
              {{ row.groupType === 'MONTH_CARD' ? '日卡' : '余额' }}
            </el-tag>
          </div>
          <div class="redeem-mobile-card__code">{{ row.redeemCode || '-' }}</div>
          <div class="redeem-mobile-card__reward">{{ formatReward(row) }}</div>
          <div class="redeem-mobile-card__meta">
            <span>使用时间：{{ formatTime(row.usedTime) }}</span>
            <span>状态：{{ row.status === 1 ? '已使用' : '未使用' }}</span>
          </div>
        </article>
      </div>
      <div v-else-if="!loading" class="redeem-mobile-empty">暂无兑换记录</div>
    </article>
  </section>
</template>

<script>
import { fetchRedeemHistory, redeemCode } from '../../api/redeem';

export default {
  name: 'RedeemView',
  data() {
    return {
      redeemCode: '',
      loading: false,
      submitting: false,
      redeemRows: []
    };
  },
  created() {
    this.loadHistory();
  },
  methods: {
    async loadHistory() {
      this.loading = true;
      try {
        const { data } = await fetchRedeemHistory();
        if (!data || data.code !== 0) {
          this.$message.error(this.mapError(data && data.message) || '兑换记录加载失败');
          return;
        }
        this.redeemRows = Array.isArray(data.data) ? data.data : [];
      } catch (error) {
        this.$message.error('兑换记录加载失败，请检查后端服务');
      } finally {
        this.loading = false;
      }
    },
    async submitRedeem() {
      if (!this.redeemCode) {
        this.$message.warning('请输入兑换码');
        return;
      }
      this.submitting = true;
      try {
        const { data } = await redeemCode(this.redeemCode);
        if (!data || data.code !== 0) {
          this.$message.error(this.mapError(data && data.message) || '兑换失败');
          return;
        }
        this.$message.success('兑换成功');
        this.$root.$emit('redeem-completed');
        this.redeemCode = '';
        this.loadHistory();
      } catch (error) {
        this.$message.error('兑换失败，请检查后端服务');
      } finally {
        this.submitting = false;
      }
    },
    formatReward(row) {
      if (!row) {
        return '-';
      }
      if (row.groupType === 'MONTH_CARD') {
        return '日卡 ' + (row.validDays || 0) + ' 天 / 每日额度 $' + this.formatAmount(row.grantAmount)
          + ' / 有效期总额度 $' + this.formatAmount(row.totalAmount || row.grantAmount);
      }
      return '余额 +' + '$' + this.formatAmount(row.grantAmount);
    },
    formatAmount(value) {
      return Number(value || 0).toFixed(4);
    },
    formatTime(value) {
      if (!value) {
        return '-';
      }
      const raw = String(value).trim();
      if (/(?:Z|[+-]\d{2}:?\d{2})$/i.test(raw)) {
        const date = new Date(raw);
        if (!Number.isNaN(date.getTime())) {
          const pad = number => String(number).padStart(2, '0');
          return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        }
      }
      return raw.replace('T', ' ').replace(/\.\d+$/, '').slice(0, 19);
    },
    mapError(message) {
      const messages = {
        REDEEM_CODE_REQUIRED: '请输入兑换码',
        REDEEM_CODE_NOT_FOUND: '兑换码不存在',
        REDEEM_CODE_ALREADY_USED: '兑换码已被使用',
        USER_NOT_FOUND: '用户不存在',
        USER_DISABLED: '当前账户不可用'
      };
      return messages[message] || message;
    }
  }
};
</script>

<style scoped>
.redeem-mobile-list,
.redeem-mobile-empty {
  display: none;
}

@media (max-width: 640px) {
  .redeem-panel .el-input {
    width: 100%;
  }

  .redeem-table {
    display: none;
  }

  .redeem-mobile-list {
    display: grid;
    gap: 12px;
  }

  .redeem-mobile-card {
    display: grid;
    gap: 10px;
    padding: 14px;
    border: 1px solid #deebe6;
    border-radius: 8px;
    background: #ffffff;
  }

  .redeem-mobile-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .redeem-mobile-card__header strong {
    min-width: 0;
    color: #17303b;
    overflow-wrap: anywhere;
  }

  .redeem-mobile-card__code {
    padding: 8px 10px;
    color: #0f856e;
    background: #eefaf6;
    border: 1px solid #d8eee7;
    border-radius: 6px;
    font-family: Consolas, "Courier New", monospace;
    font-size: 12px;
    overflow-wrap: anywhere;
  }

  .redeem-mobile-card__reward {
    color: #526b78;
    font-size: 13px;
    line-height: 1.65;
    overflow-wrap: anywhere;
  }

  .redeem-mobile-card__meta {
    display: grid;
    gap: 4px;
    padding-top: 10px;
    color: #718590;
    border-top: 1px solid #e5efeb;
    font-size: 12px;
  }

  .redeem-mobile-empty {
    display: block;
    padding: 24px 12px;
    color: #748894;
    text-align: center;
  }
}
</style>
